import { render, staticRenderFns } from "./widgetSettings.vue?vue&type=template&id=f760d6fa"
import script from "./widgetSettings.vue?vue&type=script&lang=js"
export * from "./widgetSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports